import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderModule } from "src/app/angular-core/components/dialog-header/dialog-header.module";
import { InputModule } from "src/app/angular-core/components/input/input.module";
import { ListItemModule } from "src/app/angular-core/components/list-item/list-item.module";
import { SearchBarModule } from "src/app/angular-core/components/search-bar/search-bar.module";
import { FilterPipeModule } from "src/app/angular-core/utils/pipes/filter/filter.pipe.module";
import { LocalizedDatePipe } from "src/app/angular-core/utils/pipes/localized-date/localized-date.pipe";
import { LocalizedDateModule } from "src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module";
import { HasPermissionPipeModule } from "src/app/shared/pipes/has-permission/has-permission.module";
import { LastConnectionsComponent } from "./remote-maintenance/remote-maintenance-item-info/last-connections/last-connections.component";
import { RemoteMaintenanceItemGeneralComponent } from "./remote-maintenance/remote-maintenance-item-info/remote-maintenance-item-general/remote-maintenance-item-general.component";
import { RemoteMaintenanceItemInfoComponent } from "./remote-maintenance/remote-maintenance-item-info/remote-maintenance-item-info.component";
import { ServiceConnectionsComponent } from "./remote-maintenance/remote-maintenance-item-info/service-connections/service-connections.component";
import { XpacReplacementComponent } from "./remote-maintenance/remote-maintenance-item-info/xpac-replacement/xpac-replacement.component";
import { RemoteMaintenanceComponent } from "./remote-maintenance/remote-maintenance.component";
import { ServiceRoutingModule } from "./service-routing.module";
import { ServiceComponent } from "./service.component";
import { RemoteDeviceUpdateComponent } from "./remote-device-update/remote-device-update.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MapViewComponent } from './map-view/map-view.component';
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { CcapGeneralInfoComponent } from "./remote-maintenance/remote-maintenance-item-info/ccap-general-info/ccap-general-info.component";
import { XPACManagementModule } from "../more/control-monitor/xpac-management.module";

@NgModule({
    declarations: [ServiceComponent, RemoteMaintenanceComponent,
        LastConnectionsComponent,
        RemoteMaintenanceItemInfoComponent,
        RemoteMaintenanceItemGeneralComponent,
        CcapGeneralInfoComponent,
        XpacReplacementComponent,
        ServiceConnectionsComponent,
        RemoteDeviceUpdateComponent,
        MapViewComponent],
    imports: [
        CommonModule,
        ServiceRoutingModule,
        MatIconModule,
        TranslateModule,
        MatButtonModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatDialogModule,
        SearchBarModule,
        DialogHeaderModule,
        FilterPipeModule,
        ListItemModule,
        LocalizedDateModule,
        HasPermissionPipeModule,
        MatProgressSpinnerModule,
        InputModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatListModule,
        MatTableModule,
        LeafletModule,
        XPACManagementModule,
    ],
    exports: [ServiceComponent]
})
export class ServiceModule { }
